import type { AxiosInstance } from 'axios';
import { getAuthSessionHandlers } from '@/shared/api/auth-session-handlers';
import type { ApiRequestConfig } from '@/shared/api/types';

export function applyTenantInterceptor(client: AxiosInstance): void {
  client.interceptors.request.use((config) => {
    const apiConfig = config as ApiRequestConfig;
    if (apiConfig.skipAuth) return config;

    const clinic = getAuthSessionHandlers().getActiveClinic();
    if (clinic?.clinicId) {
      config.headers['X-Tenant-Id'] = clinic.clinicId;
    }
    return config;
  });
}
